import React, { useState } from "react";

import { Counter } from "@/common/Counter";
import { useTimeout } from "@/utils/hooks";

import * as Styled from "./styles";

export type OptionResultProps = {
  text: string;
  percent: number;
  animationDelay: number;
  animationDuration: number;
};

export const OptionResult: React.FC<OptionResultProps> = (
  props: OptionResultProps
): JSX.Element => {
  const { text, percent, animationDelay, animationDuration } = props;
  const [startAnimation, setStartAnimation] = useState<boolean>(false);
  useTimeout(() => setStartAnimation(true), animationDelay);

  return (
    <Styled.OptionResult data-qa="option:result">
      <Styled.Result>
        <Styled.ProgressBar
          duration={animationDuration}
          width={startAnimation && percent > 0 ? `${percent}%` : "1px"}
        />
        <Styled.Percent>
          {!startAnimation && "0"}
          {startAnimation && (
            <Counter start={0} end={percent} duration={animationDuration} />
          )}
          %
        </Styled.Percent>
      </Styled.Result>
      <Styled.Text>{text}</Styled.Text>
    </Styled.OptionResult>
  );
};
